import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted, onUnmounted, ref, watch} from "vue";
import "@/assets/styles/main.css"
import {useRoute} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

watch(
    () => route.meta.title,
    (title) => {
      document.title = title as string || "Butterweck Digital";
    }
);

const isMobile = ref(window.innerWidth <= 1600);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 1600;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})